cacheRun.$inject = ['$rootScope', '$cacheFactory', 'AUTH_EVENTS'];

export default function cacheRun($rootScope, $cacheFactory, AUTH_EVENTS) {
    $rootScope.$on(AUTH_EVENTS.LOGOUT_SUCCESS, clearHttpCache);

    function clearHttpCache() {
        $cacheFactory.get('$http').removeAll();
    }
}
